import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Expertise } from 'src/app/shared/models/expertise';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Unavailability } from 'src/app/shared/models/unavailability';
import {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { User } from 'src/app/shared/models/security/user';
import { EmployeeType } from 'src/app/shared/models/employee/employee-type';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import { Area } from 'src/app/shared/models/area';
import { TypeStructure } from 'src/app/shared/models/typeStructure';

@Component({
	selector: 'app-employee-form',
	templateUrl: './employee-form.component.html',
	styleUrls: ['./employee-form.component.scss']
})
export class EmployeeFormComponent implements OnInit {
	@Input() employee: Employee;
	@Input() isAddForm: boolean;
	@Input() isAddressSelected: { value: boolean };
	@Input() isAddressDefault: { value: boolean };
	@Input() isAddressStructureSelected: { value: boolean };
	@Input() isAddressStructureDefault: { value: boolean };
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");

	employees: Employee[] = null;

	labelIntervenantCapitalized: string;

	selectedaddress?: Address;
	selectedaddressStructure?: Address;
	typeaheadLoading?: boolean;
	addressList: Observable<NominatimResponse[]>;
	addressStructureList: Observable<NominatimResponse[]>;
	searchResults: NominatimResponse[];

	listExpertise: Expertise[];
	listSelectedExpertise: Expertise[];
	listTypeStructure: TypeStructure[];

	isPreferencesActive = false;

	user: User;

	nomStructureActive = false;
	addressStructureActive = false;
	typeStructureActive = false;
	emailStructureActive = false;
	phoneStructureActive = false;


	public EmployeeTypeEnum = EmployeeType;

	constructor(private logger: LogService, private facade: FacadeService) {
		this.addressList = new Observable((observer: Subscriber<string>) => {
			// Runs on every search
			observer.next(this.form.value.address);
		}).pipe(
			mergeMap((token: string) =>
				this.getNominatimDisplaynameAsObservable(token)
			)
		);

		this.addressStructureList = new Observable((observer: Subscriber<string>) => {
			// Runs on every search
			observer.next(this.form.value.addressStructure);
		}).pipe(
			mergeMap((token: string) =>
				this.getAddressStructureNominatimDisplaynameAsObservable(token)
			)
		);
	}

	ngOnInit(): void {
		if (this.employee) {

			this.labelIntervenantCapitalized =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_INTERVENANT
				);

			this.facade.expertiseService.getAllExpertises().subscribe({
				next: (val) => {
					this.listExpertise = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.typeStructureService.getAllTypeStructure().subscribe({
				next: (val) => {
					this.listTypeStructure = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.user = this.facade.dataStorageService.getUser();

			this.isPreferencesActive =
				this.facade.dataStorageService.isPreferencesBeneficiaireActive();

			// Deep copy
			this.listSelectedExpertise = [...this.employee.expertises];

			if (!this.isAddForm) {
				this.toggleEmployeeTypeSelected();
				if (this.employee.address && this.employee.address.label) {
					this.isAddressDefault.value = true;
				}
				this.form.patchValue({
					firstName: this.employee.firstName,
					lastName: this.employee.lastName,
					//address: this.employee.address.label,
					birthDate:
						this.employee.birthDate !== null && this.employee.birthDate !== ''
							? new Date(this.employee.birthDate)
							: '',
					telephone: this.employee.telephone,
					email: this.employee.email,
					statutInt : this.employee.statutInt,
					nomStructure: this.employee.nomStructure,
					addressStructure: this.employee.addressStructure.label,
					phoneStructure: this.employee.phoneStructure,
					username: this.employee.username,
					emailStructure: this.employee.emailStructure,
					typeStructure: this.employee.typeStructure?.id,
				});

			} else {
				
			}
		}
	}

	// ngOnChanges(): void {
	// 	// this.mapUnavailabilities();
	// }

	onAddressSelect(event: TypeaheadMatch) {
		this.isAddressDefault.value = false;
		this.isAddressSelected.value = true;
		this.selectedaddress = new Address();
		this.selectedaddress.label = event.item.displayName;
		this.selectedaddress.latitude = event.item.latitude;
		this.selectedaddress.longitude = event.item.longitude;
		this.form.controls['address'].updateValueAndValidity();
	}

	onAddressStructureSelect(event: TypeaheadMatch) {
		this.isAddressStructureDefault.value = false;
		this.isAddressStructureSelected.value = true;
		this.selectedaddressStructure = new Address();
		this.selectedaddressStructure.label = event.item.displayName;
		this.selectedaddressStructure.latitude = event.item.latitude;
		this.selectedaddressStructure.longitude = event.item.longitude;
		this.form.controls['addressStructure'].updateValueAndValidity();
	}

	getAddressStructureNominatimDisplaynameAsObservable(
		token: string
	): Observable<NominatimResponse[]> {
		this.isAddressStructureSelected.value = false;
		this.facade.nominatimService.addressLookup(token).subscribe({
			next: (result: any) => {
				this.searchResults = result.features.map(
					(feature) =>
						new NominatimResponse(
							feature.geometry.coordinates[0],
							feature.geometry.coordinates[1],
							feature.properties.label
						)
				);
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
		return of(this.searchResults);
	}

	getNominatimDisplaynameAsObservable(
		token: string
	): Observable<NominatimResponse[]> {
		this.isAddressSelected.value = false;
		this.facade.nominatimService.addressLookup(token).subscribe({
			next: (result: any) => {
				this.searchResults = result.features.map(
					(feature) =>
						new NominatimResponse(
							feature.geometry.coordinates[0],
							feature.geometry.coordinates[1],
							feature.properties.label
						)
				);
			},
			error: (err) => {
				this.logger.error(err);
			}
		});
		return of(this.searchResults);
	}

	selectedAddressKeyUp(e: any) {
		this.isAddressDefault.value = false;
		if (this.selectedaddress && this.selectedaddress.latitude != 0) {
			if (this.selectedaddress?.label === e.value) {
				this.isAddressSelected.value = true;
			}
		}else{
			this.selectedaddress = new Address();
			this.selectedaddress.label = e.value
			this.isAddressSelected.value = true;
		}
		this.form.controls['address'].updateValueAndValidity();
	}

	selectedAddressStructureKeyUp(e: any) {
		this.isAddressStructureDefault.value = false;
		if (this.selectedaddressStructure) {
			if (this.selectedaddressStructure?.label === e.value) {
				this.isAddressStructureSelected.value = true;
			}
		}
		this.form.controls['addressStrcture'].updateValueAndValidity();
	}

	changeTypeaheadLoading(e: boolean): void {
		this.typeaheadLoading = e;
	}

	isExpertiseCheck(spec: Expertise): boolean {
		return this.listSelectedExpertise?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	/**
	 * Ajoute ou supprime la spécialité à la liste des spécialités sélectionnées
	 * @param e Element html
	 * @param spe String representant la expertise choisie
	 */
	updateSelectedExpertise(e: any, spe: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertise.some((z) => z.id === spe.id)) {
				this.listSelectedExpertise.push(spe);
			}
		} else {
			if (this.listSelectedExpertise.some((z) => z.id === spe.id)) {
				this.listSelectedExpertise = this.listSelectedExpertise.filter(
					(z) => z.id !== spe.id
				);
			}
		}
	}

	submitForm() {
		if (
			this.form.valid &&
			(this.isAddressSelected.value || this.isAddressDefault.value)
		) {
			this.isValidateButtonClicked.value = true;
			this.employee.firstName = this.form.get('firstName').value;
			this.employee.lastName = this.form.get('lastName').value;
			// if (this.isAddressSelected.value && this.selectedaddress) {
			// 	this.employee.address = this.selectedaddress;
			// } else {
			// 	if (this.isAddForm) {
			// 		const adr = new Address();
			// 		adr.label = this.form.get('address').value;
			// 		this.employee.address = adr;
			// 	}
			// }
			if (this.isAddressStructureSelected?.value && this.selectedaddressStructure) {
				this.employee.addressStructure = this.selectedaddressStructure;
			} else {
				if (this.isAddForm) {
					const adr = new Address();
					adr.label = this.form.get('addressStructure')?.value;
					this.employee.addressStructure = adr;
				}
			}
			
			this.employee.expertises = this.listSelectedExpertise;
			//this.employee.birthDate = this.form.get('birthDate').value;
			this.employee.telephone = this.form.get('telephone').value;
			this.employee.statutInt = this.form.get('statutInt').value;
			this.employee.email = this.form.get('email').value;
			this.employee.username = this.form.get('username').value;
			this.employee.nomStructure = this.form.get('nomStructure')?.value;
			this.employee.typeStructure = this.listTypeStructure.find(x => x.id == this.form.get('typeStructure').value); 
			this.employee.emailStructure = this.form.get('emailStructure')?.value;
			this.employee.phoneStructure = this.form.get('phoneStructure')?.value;
			this.sendForm.emit();
		} else {
			// this.facade.toastService.createErrorToast();
			this.isValidateButtonClicked.value = false;
		}
	}

	toggleEmployeeTypeSelected() {
		switch(this.statutInt.value) { 
			case this.EmployeeTypeEnum.INT: {
				this.nomStructureActive = false;
				this.addressStructureActive = false;
				this.typeStructureActive = false;
				this.emailStructureActive = false;
				this.phoneStructureActive = false;

				this.form.controls['nomStructure'].setValue('');
				this.form.controls['typeStructure'].setValue('');
				this.form.controls['addressStructure'].setValue('');
				this.form.controls['emailStructure'].setValue('');
				this.form.controls['phoneStructure'].setValue('');
				break;
			}
			case this.EmployeeTypeEnum.EXT: {
				this.nomStructureActive = true;
				this.addressStructureActive = true;
				this.typeStructureActive = true;
				this.emailStructureActive = true;
				this.phoneStructureActive = true;
				break;
			}
		}
	}

	get firstName() {
		return this.form.get('firstName');
	}
	get lastName() {
		return this.form.get('lastName');
	}
	// get address() {
	// 	return this.form.get('address');
	// }
	get competence() {
		return this.form.get('competence');
	}
	get telephone() {
		return this.form.get('telephone');
	}

	isAddressValidValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			return !(this.isAddressDefault.value || this.isAddressSelected.value)
				? { invalidAddress: { value: control.value } }
				: null;
		};
	}

	get statutInt() {
		return this.form.get('statutInt');
	}
	get email() {
		return this.form.get('email');
	}
	get birthDate() {
		return this.form.get('birthDate');
	}
	get username() {
		return this.form.get('username');
	}
	get nomStructure() {
		return this.form.get('nomStructure');
	}
	get emailStructure() {
		return this.form.get('emailStructure');
	}
	get phoneStructure() {
		return this.form.get('phoneStructure');
	}
	get addressStructure() {
		return this.form.get('addressStructure');
	}
	get typeStructure() {
		return this.form.get('typeStructure');
	}
}
